import { WifiOff } from "lucide-react";

export function OfflineBadge() {
  return (
    <span className="inline-flex items-center gap-1 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-0.5 text-xs font-medium text-amber-700">
      <WifiOff className="h-3 w-3" />
      Mode hors ligne
    </span>
  );
}
